import { getBlockProps } from "../blocks-parser";

const props = {
  content: {
    source: "text",
    selector: "code",
  },
};

const codeSchema = {
  blockSlug: "grigora/code",
  props,
  isMatch: (node) =>
    node.nodeName === "PRE" &&
    node.children.length === 1 &&
    node.firstChild.nodeName === "CODE",
  transform: (node) => {
    const blockProps = getBlockProps("grigora/code", node.outerHTML, props);
    return {
      blockSlug: "grigora/code",
      blockProps: blockProps,
    };
  },
  schema: {
    pre: {
      children: {
        code: {
          children: {
            "#text": {},
          },
        },
      },
    },
  },
};

export { codeSchema };
